import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AutenticacionService } from '../modules/auth/services/autenticacion.service';
import { environment } from '../../environments/environment';

let isLoggingOut = false;

export const authExpiredInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const autenticacionService = inject(AutenticacionService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !isLoggingOut) {
        isLoggingOut = true;

        autenticacionService.logout();

        const a = document.createElement('a');
        a.href = environment.AUTH_LOGOUT_TAB_URL;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        router.navigate(['/login']);

        setTimeout(() => {
          isLoggingOut = false;
        }, 1000);
      }

      return throwError(() => error);
    })
  );
};
